// src/redux/reducers/authReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  userInfo:{},
  role: null,
  orgId: null,
  loading: false,
  error: null,
};

const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    verifyToken: (state) => {
      state.loading = true;
    },
    loginRequest: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.userInfo = action.payload?.userInfo;
      state.role = action.payload?.userInfo?.role;
      state.orgId = action.payload?.orgId || action.payload?.orgInfo?.id;
      state.loading = false;
      state.error = null;
    },    
    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userInfo = {};
      state.loading = false;
      state.error = null;
      state.role = null;
      state.orgId = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("selecteOrg");
    },
  },
});

export const { verifyToken, loginRequest, loginSuccess, loginFailure, logout } = authReducer.actions;
export default authReducer.reducer;
